<template>
    <div id="app">
        <template v-if="coreParams">
            <div id="wrapper"
                 :class="{'-blur': showMySelectionHelpers && !isMobile, '-is-mobile': isMobile}">
                <navbar v-if="isFullPage"/>
                <sidebar v-if="coreParams.theme_settings.sidebar && !isMobile && isFullPage"/>
                <main id="main" :class="{'-has-common-menu': mobileCommonMenu}">
                    <router-view></router-view>
                </main>
                <template v-if="isMobile">
                    <mobile-album-menu v-if="$route.name === 'album' || $route.name === 'tag'"/>
                    <mobile-main-menu v-else-if="availablePagesForMenu"/>
                    <mobile-lang-switcher
                            v-if="availablePagesForLangSwitcher && coreParams.multi_language && availableLocales.length > 1"/>
                    <mobile-cart-menu v-if="$route.name === 'cart'"/>
                    <mobile-cart-delete-menu v-if="$route.name === 'cart'"/>
                </template>
                <Footer v-if="!isMobile && isFullPage && !hideFooter"/>
                <order v-if="photo || myOrder && !!myOrder.photos.length"/>
                <Set v-if="set"/>
                <photo-editor v-if="drawing"/>
            </div>
            <!--<div class="top-menu-toggle-overlay" v-if="coreParams.theme_settings.sidebar"
                 @click="$store.dispatch('SHOW_SIDEBAR', !showSidebar)"></div>-->
            <helpers-my-selection v-if="showMySelectionHelpers && !isMobile"/>
            <mobile-orientation-detect v-if="isMobile && isLandscapeOrientation"/>
        </template>
        <router-view v-else></router-view>
    </div>
</template>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Inconsolata:400,700&display=swap&subset=latin-ext');

    @import "scss/variables";

    body {
        color: var(--text-color);
        font-weight: var(--font-weight-text);
        transition: all .3s ease;
        background-color: var(--bg-color);

        &.-sidebar:not(.-is-mobile) {
            padding-left: $sidebar-width;

            .container {
                max-width: 1366px !important;
                padding-left: 40px;
                padding-right: 40px;
            }

            .top-menu {
                background-color: transparent;
                pointer-events: none;

                &-actions {
                    pointer-events: auto;
                }
            }

            #main {
                z-index: inherit;
            }

            #content {
                padding-top: 90px;
            }

            #back-btn {
                box-shadow: none !important;
            }
        }

        &.-is-mobile {

            #content {
                padding: 120px 0 100px;
            }

            .container {
                padding-left: 20px;
                padding-right: 20px;
            }

            .row {
                margin-left: -20px;
                margin-right: -20px;
            }

            [class*="col-"] {
                padding-left: 20px;
                padding-right: 20px;
            }
        }
    }

    #app,
    #wrapper {

        &.-blur {
            filter: blur($blur);
            overflow: hidden;
            pointer-events: none;
            z-index: 0;
        }
    }

    #wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
    }

    #main {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        z-index: 0;

        &.-has-common-menu {
            z-index: 3;
        }
    }

    #content {
        position: relative;
        flex-grow: 1;
        padding: 190px 0 90px;
        background-color: var(--bg-secondary-color);

        &.-album {
            background-color: var(--bg-color);
        }
    }

    .material-icon {
        font-size: 1.5rem !important;
    }
</style>

<script>
  import './scss/app.scss';

  import MobileMainMenu from './components/MobileMainMenu.vue';
  import MobileAlbumMenu from './components/MobileAlbumMenu.vue';
  import MobileLangSwitcher from './components/MobileLangSwitcher.vue';
  import MobileOrientationDetect from './components/MobileOrientationDetect.vue';
  import MobileCartMenu from './components/MobileCartMenu.vue';
  import MobileCartDeleteMenu from './components/MobileCartDeleteMenu.vue';

  import Navbar from './components/Navbar.vue';
  import Sidebar from './components/Sidebar.vue';
  import Footer from './components/Footer.vue';
  import Order from './components/Order.vue';
  import Set from './components/Set.vue';
  import PhotoEditor from './components/PhotoEditor.vue';
  import HelpersMySelection from './components/HelpersMySelection.vue';

  import layout from 'src/mixins/layout';

  import {colorProcess} from '../../plugins/color-process';

  import cssVars from 'css-vars-ponyfill';
  import {isMobile} from 'mobile-device-detect';
  import {router} from '../../router';

  const MIN_TABLET_SIZE = 1024;

  export default {
    mixins: [layout],
    components: {
      MobileMainMenu,
      MobileAlbumMenu,
      MobileLangSwitcher,
      MobileCartMenu,
      MobileCartDeleteMenu,
      MobileOrientationDetect,
      Navbar,
      Sidebar,
      Footer,
      Order,
      Set,
      PhotoEditor,
      HelpersMySelection,
    },
    data() {
      return {
        isFullPage: true,
        isLandscapeOrientation: false,
        hideFooter: false,
      };
    },
    computed: {
      mobileCommonMenu() {
        return this.$store.getters.MOBILE_COMMON_MENU;
      },
      availablePagesForMenu() {
        if (this.$route.name === 'login' && this.checkout && this.checkout.authType === 'user') {
          return false;
        } else if (this.$route.name === 'registration' && this.checkout && this.checkout.authType === 'registration') {
          return false;
        } else if (['checkout', 'finish'].includes(this.$route.name)) {
          return false;
        }

        return true;
      },
      availablePagesForLangSwitcher() {
        return !(this.orderStep && this.orderStep === 1); // !['order', 'checkout', 'finish'].includes(this.$route.name)
      },
    },
    watch: {
      /*photo(photo) {
        document.documentElement.style.overflow = photo ? 'hidden' : 'visible';
        document.body.style.overflow = photo ? 'hidden' : 'visible';
      },
      set(set) {
        if (!this.myOrder || this.myOrder && !this.myOrder.photos.length) {
          document.documentElement.style.overflow = set ? 'hidden' : 'visible';
          document.body.style.overflow = set ? 'hidden' : 'visible';
        }
      },
      myOrder(order) {
        if (!this.set) {
          document.documentElement.style.overflow = order && !!order.photos.length
              ? 'hidden'
              : 'visible';
          document.body.style.overflow = order && !!order.photos.length
              ? 'hidden'
              : 'visible';
        }
      },*/
      '$route'(route) {
        if (['album', 'tag'].includes(route.name)) {
          let tag = null;

          if (router.currentRoute.query.tag) {
            tag = router.currentRoute.query.tag;
          } else if (router.currentRoute.params.tag) {
            tag = router.currentRoute.params.tag;
          }

          this.$store.commit('SET_ALBUM_TAG', tag);
        }

        /*if (!['album', 'tag', 'order', 'photo'].includes(route.name)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }*/

        let fullPages = ['checkout', 'finish'];

        if (this.checkout) {
          switch (this.checkout.authType) {
            case 'user':
              fullPages.push('login');
              break;
            case 'registration':
              fullPages.push('registration');
              break;
          }
        }

        this.isFullPage = fullPages.indexOf(route.name) < 0;
        this.hideFooter = false; /*['home'].indexOf(route.name) >= 0*/

        this.$store.dispatch('CLOSE_ALL_MOBILE_MENU');
      },
    },
    methods: {
      initTheme() {
        /*if (this.coreParams.theme_color) {
          document.body.classList.add(`theme-${this.coreParams.theme_color}`);

          switch (this.coreParams.theme_color) {
            case 'light':
            case 'dark':
              import(`./scss/theme-${this.coreParams.theme_color}.scss`);
              break;
          }
        }*/

        if (this.coreParams.shop_design.javascript) {
          let jsCode = this.coreParams.shop_design.javascript,
              styleElement = document.createElement('script');

          styleElement.appendChild(document.createTextNode(jsCode));
          document.getElementsByTagName('body')[0].appendChild(styleElement);
        }

        if (this.coreParams.shop_design.css) {
          let cssRules = this.coreParams.shop_design.css,
              styleElement = document.createElement('style');

          styleElement.appendChild(document.createTextNode(cssRules));
          document.getElementsByTagName('head')[0].appendChild(styleElement);
        }

        if (this.coreParams.shop_design.page_background_color) {
          cssVars({variables: {'--page-bg-color': this.coreParams.shop_design.page_background_color}});
        }

        if (this.coreParams.shop_design.page_background_image_original) {
          cssVars(
              {variables: {'--page-bg-image': `url(${this.coreParams.shop_design.page_background_image_original})`}});
        }

        if (this.coreParams.theme_settings) {
          const colorPalette = this.coreParams.theme_settings.color_palette;

          for (const prop in colorPalette) {
            this.assignThemeColors(prop, colorPalette[prop]);
          }
        }

        if (this.coreParams.theme_settings.coupon_color_palette) {
          const couponColorPalette = this.coreParams.theme_settings.coupon_color_palette;

          for (const prop in couponColorPalette) {
            this.setDefaultConfig(prop, couponColorPalette[prop]);

            if (['coupon-bg', 'coupon-banner-bg'].includes(prop)) {
              this.setDefaultConfig(`${prop}-dark`, colorProcess.hexToHSL(couponColorPalette[prop], 'dark'));
            }
          }
        }

        for (const key in this.coreParams.theme_settings.typography) {
          if (this.coreParams.theme_settings.typography.hasOwnProperty(key)) {
            const typographyItem = this.coreParams.theme_settings.typography[key];

            this.setDefaultConfig(`font-family-${key}`, typographyItem.font_family);
            this.setDefaultConfig(`font-weight-${key}`, typographyItem.font_weight);
          }
        }
      },
      assignThemeColors(key, prop) {
        cssVars({
          variables: {
            [`--${key}`]: prop,
            [`--${key}-light`]: colorProcess.hexToHSL(prop, 'light'),
            [`--${key}-dark`]: colorProcess.hexToHSL(prop, 'dark'),
          },
        });
      },
      setDefaultConfig(key, prop) {
        cssVars({variables: {[`--${key}`]: prop}});
      },
      orientationDetect() {
        if (isMobile && screen.width < MIN_TABLET_SIZE) {
          const orientation = window.screen.msOrientation ||
              (window.screen.orientation || window.screen.mozOrientation || {}).type;

          if (typeof orientation === 'undefined') {
            switch (window.orientation) {
              case -90:
                this.isLandscapeOrientation = true;
                break;
              case 90:
                this.isLandscapeOrientation = true;
                break;
              default:
                this.isLandscapeOrientation = false;
                break;
            }
          } else {
            this.isLandscapeOrientation = (orientation === 'landscape-primary' || orientation === 'landscape-secondary')
                && (window.orientation === 90 || window.orientation === -90 || window.orientation === 180 ||
                    !window.orientation);
          }
        }
      },
    },
    created() {
      this.isFullPage = ['checkout', 'finish'].indexOf(this.$route.name) < 0;
      this.hideFooter = false; /*['home'].indexOf(route.name) >= 0*/

      if (this.coreParams) {
        this.initTheme();
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.orientationDetect();

        window.addEventListener('orientationchange', () => {
          this.orientationDetect();
        });
      });
    },
  };
</script>